import CommCdDescTable from './CommCdDescTable';
import CommCdLangTable from './CommCdLangTable';

export default {
	CommCdDescTable,
	CommCdLangTable
};

export { CommCdDescTable, CommCdLangTable };
